import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-central',
  templateUrl: './help-central.component.html',
  styleUrls: ['./help-central.component.css']
})

export class HelpCentralComponent implements OnInit {

  script: string = ""
  public isAdmin: boolean
  loading: boolean = false
  loadingMessage: string = "Conectando com a API. Isso pode demorar um pouco!"
  constructor() {
  }

  ngOnInit() {

  }

}
